import React, { Component } from 'react';
import CachedImg from '../CachedImg/CachedImg';
class loadImage extends Component {
  render() {
    return (
      <div style={{ height: '100%', width: '100%', overflow: 'hidden', display: 'flex' }}>
        {this.props.image_url && (
          <CachedImg
            style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
            src={this.props.image_url}
            alt='img'
            width={this.props.width}
            height={this.props.height}
          ></CachedImg>
        )}
      </div>
    );
  }
}

export default loadImage;
